export default "__VITE_ASSET__Ds0$5BNg__"